import React from 'react';
import styled, { css } from 'styled-components';
import ImagePlaceholder from 'js/components/common/ImagePlaceholder';

const showBackgroundImage = css`
  background: ${({ src }) => `url(${src}) no-repeat center center`};
  background-size: cover;
`;

export default styled(({ src, ...rest }) => {
  if (src.endsWith('svg')) {
    return <ImagePlaceholder noHover {...rest} />;
  }
  return <div {...rest} />;
})`
  ${({ src }) => !src.endsWith('svg') && showBackgroundImage}
  width: 3rem;
  height: 3rem;
  float: left;
  margin-right: 1rem;
  border-radius: 0.25rem;
`;
